export const goToTop = () => {
  const caseview = document
    .getElementsByClassName("case-view")
    .item(0) as Element;
  caseview.scrollTop = 0;
};
